import * as formatter from "../../../../utils/formatter";
import {ORDER_STATUS, DELIVERY_COMPANY} from "../../../../utils/codes";
// import {format, subDays} from "date-fns";

export const defaultSorted = [{ dataField: "no", order: "asc" }];

export const orderStatusFilterOptions = ORDER_STATUS.map(({key, label}) => ({ key, label }));

export const deliveryCompanyList = DELIVERY_COMPANY.map(c => c.label);

export const sizePerPageList = [
  { text: "10개 보기", value: 10 },
  { text: "30개 보기", value: 30 },
  { text: "50개 보기", value: 50 },
  { text: "100개 보기", value: 100 },
];

export const initialFilter = {
  filter: {
    ordNo: "",
    ordSttsCd: "",
    goodsNo: "",
    goodsNm: "",
    startDt: "",
    endDt: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "no",
  pageNumber: 1,
  pageSize: 30
};

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordNo",
    text: "주문번호",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordSttsCd",
    text: "주문상태",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.dot(ORDER_STATUS),
  },
  {
    keyField: "no",
    dataField: "ordUserNm",
    text: "주문자명",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordQty",
    text: "총 구매 수량",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.count
  },
  {
    keyField: "no",
    dataField: "payAmt",
    text: "결제금액",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.price
  },
  {
    keyField: "no",
    dataField: "saleNo",
    text: "링크코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordDtime",
    text: "주문 일시",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.date
  },
];
